// @flow

/***
 * Make first letter of each word Uppercase and lowercase the rest
 * @param {string} str text to be Capitalized
 * @return {string} Capitalized text
 */
export const capitalize = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/(^\w)|(\s+\w)/g, letter => letter.toUpperCase());
};
